import { useEffect, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";

const navItems = [
  { to: "/", label: "首页" },
  { to: "/channels", label: "投稿通道" },
  { to: "/guide", label: "安全指南" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
  { to: "/contact", label: "联系我们" },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === "/" || location.pathname === "";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const dark = !scrolled && !menuOpen;

  const brand = (
    <NavLink to="/" className="flex items-center gap-2.5 group">
      <span
        className={`w-10 h-10 flex items-center justify-center rounded-md text-lg transition-colors ${
          dark ? "bg-background-50/15 text-background-50" : "bg-primary-500 text-background-50"
        }`}
      >
        <i className="ri-mic-line"></i>
      </span>
      <span className="flex flex-col leading-none">
        <span
          className={`font-heading text-xl font-bold tracking-wide transition-colors ${
            dark ? "text-background-50" : "text-foreground-950"
          }`}
        >
          潜声投稿
        </span>
        <span
          className={`text-[11px] mt-1 tracking-[0.2em] transition-colors ${
            dark ? "text-background-200" : "text-foreground-500"
          }`}
        >
          ANONYMOUS TIPS
        </span>
      </span>
    </NavLink>
  );

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 w-full transition-all duration-300 ${
        dark
          ? "bg-transparent border-b border-transparent"
          : "bg-background-50/95 backdrop-blur-md border-b border-background-200"
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex items-center justify-between h-16 md:h-20">
          {isHome ? <h1 className="m-0">{brand}</h1> : brand}

          <nav className="hidden md:flex items-center gap-1" aria-label="主导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-3.5 py-2 rounded-md text-[15px] transition-colors whitespace-nowrap ${
                    isActive
                      ? dark
                        ? "text-background-50 bg-background-50/15"
                        : "text-primary-700 bg-primary-100"
                      : dark
                        ? "text-background-100 hover:text-background-50 hover:bg-background-50/10"
                        : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <NavLink
              to="/channels"
              className="hidden md:inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-500 text-foreground-950 text-sm font-medium hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-send-plane-fill"></i>
              立即投稿
            </NavLink>

            <button
              type="button"
              aria-label={menuOpen ? "关闭菜单" : "打开菜单"}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((prev) => !prev)}
              className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl transition-colors cursor-pointer ${
                dark ? "text-background-50 hover:bg-background-50/10" : "text-foreground-950 hover:bg-background-100"
              }`}
            >
              <i className={menuOpen ? "ri-close-line" : "ri-menu-line"}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <nav className="px-4 py-4 flex flex-col gap-1" aria-label="移动端导航">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `px-4 py-3 rounded-md text-base transition-colors ${
                    isActive
                      ? "text-primary-700 bg-primary-100"
                      : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <NavLink
              to="/channels"
              className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-md bg-accent-500 text-foreground-950 font-medium hover:bg-accent-400 transition-colors cursor-pointer"
            >
              <i className="ri-send-plane-fill"></i>
              立即投稿
            </NavLink>
          </nav>
        </div>
      )}
    </header>
  );
}